import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
 
import { TRANSLATIONS_EN } from "../lang/en";
import { TRANSLATIONS_ES } from "../lang/es";
 
i18n
 .use(LanguageDetector)
 .use(initReactI18next)
 .init({
	fallbackLng: 'en',
  	lng: 'en',
   	resources: {
    	en: {
       		translation: TRANSLATIONS_EN
     	},
     	es: {
       		translation: TRANSLATIONS_ES
     	}
   	},
   	react:{
		bindI18n: false
	}
 });
let lang = navigator.language.split("-");
i18n.changeLanguage(lang[0]);

export default i18n;